<template>
  <v-card flat>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="save" round>Save Changes</v-btn>
    </v-toolbar>
    <v-container grid-list-xs>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text font-weight-bold">General Information</h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="addressinfo.name"
                    label="*Network Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="addressinfo.abbreviation"
                    label="Network Abbreviation"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="locationnodes"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="addressinfo.locationNodeId"
                    label="*Associated Network Node"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="regions"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="addressinfo.regionId"
                    label="*Region"
                  ></v-autocomplete>
                </v-flex>
                <v-layout justify-center align-center wrap>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      hide-no-data
                      flat
                      color="primary"
                      :items="networkStatus"
                      v-model="addressinfo.networkStatus"
                      label="*Network Installation Status"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      hide-no-data
                      flat
                      color="primary"
                      :items="backhaulTypes"
                      v-model="addressinfo.backhaulType"
                      label="*Network Backhaul Type"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      color="primary"
                      v-model="addressinfo.isMDU"
                      label="This network has Multi-Dwelling Units"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-card-text>
           <h2 class="dark-grey--text font-weight-bold" :key="addPolygon">
              Address Information
              <v-btn
                round
                color="primary"
                class="white--text"
                v-if="polyData.length > 0 && editPolygon"
                @click="updatePolygon()"
                >Update Polygon</v-btn
              >
              <v-btn
                round
                color="primary"
                class="white--text"
                v-else-if="polyData.length > 0 && !editPolygon"
                @click="editPolygon = true"
                >Edit Coverage Area</v-btn
              >
              <v-btn
                round
                color="primary"
                class="white--text"
                v-if="polyData.length > 0 && !editPolygon"
                @click="deletePolygon()"
                >Delete Coverage Area</v-btn
              >
              <v-btn
                v-else-if="!addPolygon"
                round
                color="primary"
                dark
                @click="addPolygon = true"
                >Add Coverage Area</v-btn
              >
              <v-btn
                v-else-if="addPolygon"
                round
                color="primary"
                dark
                @click="saveNewPolygon()"
                >Save Coverage Area</v-btn
              >
            </h2>
            <v-layout justify-center>
              <v-flex xs4 mx-1>
               <v-text-field
                          v-model="searchLocation"
                          id="pac-input"
                          clearable
                          placeholder="Find Address"
                        ></v-text-field>
            </v-flex>
            </v-layout>
            <v-container grid-list-xs>
              <v-layout wrap>
                <!-- <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="addressinfo.streetNumber"
                    label="Estate Street Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="addressinfo.streetName"
                    label="*Estate Street Name"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="addressinfo.suburb"
                    label="Suburb"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="addressinfo.town" label="Town" persistent-hint required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="addressinfo.city" label="City" persistent-hint required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="addressinfo.country"
                    label="*Country"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="addressinfo.geoLongitude"
                    label="Longitude"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="addressinfo.geoLatitude" label="Latitude" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="addressinfo.geoHightAboveGroundLevel"
                    label="Height above ground level"
                    persistent-hint
                  ></v-text-field>
                </v-flex>-->

                <gmap-map
                :key="key"
                  ref="mapRef"
                  :center="center"
                  :zoom="zoom"
                  :options="{
        styles: myStyles,
        streetViewControl: false
      }"
                  style="width: 100%; height: 40vh"
                  @click="
                    !addPolygon ? getAddressData($event) : addPolyPoint($event)
                  "
                >
                  <gmap-marker :position="center" :draggable="editPolygon" @dragend="getAddressData($event)"></gmap-marker>
                  <!-- <gmap-polygon :paths="newPolyPaths" ></gmap-polygon> -->
                  <gmap-polygon
                    :paths="polyData"
                    :editable="editPolygon"
                    :options="{
                      strokeColor: $store.state.currentOrg.org.primaryColour,
                      fillOpacity: 0.3,
                      strokeWeight: 2,
                      fillColor: $store.state.currentOrg.org.primaryColour,
                    }"
                    @paths_changed="savePolyData($event)"
                    @click="getAddressData($event)"
                  ></gmap-polygon>
                 <gmap-polygon
                    :paths="newPolyData"
                    :editable="addPolygon"
                    :options="{
                      strokeColor: $store.state.currentOrg.org.primaryColour,
                      fillOpacity: 0.3,
                      strokeWeight: 2,
                      fillColor: $store.state.currentOrg.org.primaryColour,
                    }"
                    @paths_changed="updateNewPolygon($event)"
                  ></gmap-polygon>
                  <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen=false"
                    :key="key"
                  >
                    <v-card
                      flat
                      color="white"
                      :key="key"
                      v-if="infoWindowContent&&infoWindowContent.formatted_address"
                    >
                      <v-card-title flat color="primary">
                        <h3 class="title grey--text">{{infoWindowContent.formatted_address}}</h3>
                      </v-card-title>
                      <v-card-actions>
                        <v-layout justify-center>
                          <v-btn
                            round
                            color="primary"
                            class="white--text"
                            @click="setPosition(infoWindowContent)"
                          >Update Position</v-btn>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                    <v-card v-else flat color="white">
                      <v-card-text>
                        <v-layout justify-center wrap>
                          <v-flex xs10>
                            <v-progress-circular size="30" indeterminate color="primary"></v-progress-circular>
                          </v-flex>
                          <v-flex xs8>
                            <h3 class="grey--text">Getting address information</h3>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </gmap-info-window>
                </gmap-map>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text font-weight-bold">
              Sub Complexes
              <v-icon round color="primary" @click="addSubComplexModal=true">add</v-icon>
            </h2>
            <v-data-table
              :headers="subComplexHeaders"
              :items="subcomplexes"
              item-key="id"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="justify-center layout px-0">
                  <v-icon small @click="editSubComplex(props.item)">settings</v-icon>
                </td>
                <td class="text-xs-center">{{props.item.subComplexName}}</td>
                <td
                  class="text-xs-center"
                  v-if="props.item.customerOrganisationId!==null"
                >{{props.item.customerOrganisation.name}}</td>
                <td class="text-xs-center" v-else></td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <h2>Data Service Details</h2>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout col wrap>
                
                <v-flex
                  xs12
                  sm6
                  md6
                  v-if="addressinfo.lineRentalIncluded&&!addressinfo.hasSingleLineRentalCustomer"
                ></v-flex>

                <v-flex xs12 sm6 md6>
                  <v-switch
                    v-model="addressinfo.routerInstallationFee"
                    label="Is there a Router Installation Fee?"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="addressinfo.routerInstallationFee"></v-flex>
                <v-flex xs12 sm6 md6 v-show="!addressinfo.routerInstallationFee"></v-flex>
                <v-flex xs10 sm5 md5 v-show="addressinfo.routerInstallationFee" mx-1>
                  <v-text-field
                  type="number"
                    v-model="addressinfo.residentialRouterInstallationFeeAmount"
                    label="Residential Installation Fee Amount (Incl. VAT)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5 md5 v-show="addressinfo.routerInstallationFee" mx-1>
                  <v-text-field
                  type="number"
                    v-model="addressinfo.businessRouterInstallationFeeAmount"
                    label="Business Installation Fee Amount (Incl. VAT)"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-switch v-model="addressinfo.activationFee" label="Is there a Setup fee?"></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 v-show="!addressinfo.activationFee"></v-flex>
                <v-flex xs10 sm5 md5 v-show="addressinfo.activationFee" mx-1>
                  <v-text-field
                  type="number"
                    v-model="addressinfo.activationFeeAmount"
                    label="Setup Fee Amount (excl. VAT)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>

       
      </v-layout>
    </v-container>

    <v-dialog persistent v-model="addSubComplexModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Add Sub Complex</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.subComplexName" label="*Sub Complex Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  class="autoCompleteGlueTheme"
                  :items="customers"
                  :search-input.sync="search"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.customerOrganisationId"
                  flat
                  hide-details
                  label="Billable Organisation"
                  solo-inverted
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="saveSubComplex">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editSubComplexModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Edit Sub Complex</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.subComplexName" label="*Sub Complex Name"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  class="autoCompleteGlueTheme"
                  :items="customers"
                  :search-input.sync="search"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.customerOrganisationId"
                  flat
                  hide-details
                  label="Billable Organisation"
                  solo-inverted
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="updateSubComplex">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import Api from "@/services/Api";
export default {
  props: [
    "addressinfo",
    "locationnodes",
    "networkfibrefarmers",
    "allfibrefarmers",
    "customers",
    "subcomplexes",
    "regions",
  ],
  data() {
    return {
      center: { lng: -33.919473, lat: 18.427059},
      zoom: 15,
      y: "top",
      snackbar: false,
      text: "",
      addFibreFarmerModal: false,
      editSubComplexModal: false,
      addSubComplexModal: false,
      editFibreFarmerModal: false,
      editPolygon: false,
      markerData: {},
      geocoder: null,
      infoWindowContent: {},
      currentPolyData: [],
      polyData: [],
      newPolyData: [],
      polygon: null,
      key: 0,
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      myStyles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
      fibreFarmerTypes: ["Carrot Farmer", "Apple Farmer", "Grape Farmer"],
      networkStatus: ["Planned", "In Progress", "Live"],
      backhaulTypes: ["Open Band Wireless", "Licensed Wireless", "Fibre", "Hybrid"],
      subComplexHeaders: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Sub Complex Name",
          align: "center",
          value: "subComplexName",
        },
        {
          text: "Customer",
          align: "center",
          value: "levyCustomer.name",
        },
      ],
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Fibre Farmer Type",
          align: "center",
          value: "type",
        },
        {
          text: "Organisation",
          align: "center",
          value: "customerOrganisation.name",
        },
      ],
      editedItem: {
        id: null,
        type: "",
        locationNetworkId: null,
        customerOrganisationId: null,
        vasProfitPercentage: 0,
        basProfitPercentage: 0,
        basExpense: 0,
        vasExpense: 0,
        isInvestor: false,
        purchasedCpe: false,
        subComplexName: "",
        levyCustomerId: null,
        isActive: true,
        isDeleted: false,
      },
      defaultItem: {
        id: null,
        type: "",
        locationNetworkId: null,
        customerOrganisationId: null,
        vasProfitPercentage: 0,
        basProfitPercentage: 0,
        basExpense: 0,
        vasExpense: 0,
        isInvestor: false,
        purchasedCpe: false,
        subComplexName: "",
        levyCustomerId: null,
        isActive: true,
        isDeleted: false,
      },
    };
  },
  created() {
   this.geocoder = new google.maps.Geocoder();
  },
  mounted(){
    this.getNetworkPolygon();
    if (!this.addressinfo.geoLatitude || !this.addressinfo.geoLongitude) {
      this.geolocate();
    }
    this.geocoder = new google.maps.Geocoder();
    
  },
  methods: {
    getNetworkPolygon() {
      this.polygon = {}
            this.polyData = []
      Api()
        .get(
          "/locationNetworkPolygon/network/" +
            this.$route.params.locationNetworkId
        )
        .then((response) => {
          let coordinates = [];
          if (response.data) {
            coordinates = JSON.parse(response.data.coordinates);
          }

          let result = [];
          if (coordinates.length > 0) {
            for (let i = 0; i < coordinates[0].length; i++) {
              let gData = new google.maps.LatLng(
                parseFloat(coordinates[0][i][1]),
                parseFloat(coordinates[0][i][0])
              );
              result.push(gData);
            }
          }
          if (parseFloat(this.addressinfo.geoLatitude)!=0 && parseFloat(this.addressinfo.geoLongitude)!=0) {
            this.center = new google.maps.LatLng(
              this.addressinfo.geoLatitude,
              this.addressinfo.geoLongitude
            );
          } else if (coordinates.length > 0) {
            this.center = new google.maps.LatLng(
              parseFloat(coordinates[0][0][1]),
              parseFloat(coordinates[0][0][0])
            );
          }

          if (result.length > 0) {
            this.polygon = response.data;
            this.polyData = result;
            this.plotMap();
            
          }
          this.initMapAutocomplete()
        });
    },
    savePolyData(data) {
       let key = Object.keys(data)[0]
      let array = data[key][0][key].map((x) => [x.lng(), x.lat()]);
      this.currentPolyData = [array];
      // let key = Object.keys(data)[0]
      // let array = data[key][0][key].map((x) => [x.lng(), x.lat()]);
      // this.currentPolyData = [array];
    },
    updatePolygon() {
       if (this.currentPolyData.length > 0) {
        Api()
          .put("/locationNetworkPolygon/" + this.polygon.id, {
            coordinates: JSON.stringify(this.currentPolyData),
          })
          .then((response) => {
            this.editPolygon = false;
          });
      } else {
        this.editPolygon = false;
      }
    },
    async initMapAutocomplete() {
      const input = document.getElementById("pac-input");
      const autocomplete = new google.maps.places.Autocomplete(input, {
       
      });
      autocomplete.setComponentRestrictions({
        country: ["za"],
      });
      google.maps.event.addListener(autocomplete, "place_changed", async () => {
        
        const place = autocomplete.getPlace();
        const location = place.geometry.location;

        var latlng = new google.maps.LatLng(
        location.lat(),
        location.lng()
      );
      this.infoWindowPos = {
        lat: location.lat(),
        lng: location.lng(),
      };
      let resultData = null;
      let geocoder = new google.maps.Geocoder()
      await geocoder.geocode(
        {
          latLng: latlng,
        },
        async function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              resultData = results[1];
            } else {
              alert("No results found");
            }
          } else {
            alert("Geocoder failed due to: " + status);
          }
        }
      );
      setTimeout(() => {
        this.infoWindowContent = resultData;
        this.key += 1;
      }, 1500);
      setTimeout((this.infoWinOpen = true), 1600);
      })
      },
    plotMap() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
        // this.map.data.addGeoJson(this.coordinates);
        this.map.data.setStyle(function (feature) {
          return {
            fillColor: this.$store.state.currentOrg.org.primaryColour,
            fillOpacity: 0.5,
            strokeWeight: 2,
            strokeColor: this.$store.state.currentOrg.org.primaryColour,
          };
        });
        // this.map.data.addListener("click", (event) => {

        //   this.polyInfo = {
        //     type: "Network",
        //     name: event.feature.j.name,
        //     units: event.feature.j.units,
        //     fno: event.feature.j.fno,
        //     network: event.feature.j.network,
        //   };
        //   this.openWindow(event);
        //   let testPoly = new google.maps.Polygon({
        //     paths: event.feature.getGeometry().getAt(0).getArray(),
        //   });
        //   if (
        //     google.maps.geometry.poly.containsLocation(event.latLng, testPoly)
        //   ) {
        //     // This works now, still have to loop through the arrays for the multipolygons
        //   }
        // });
      });
    },
    editSubComplex(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editedItem = Object.assign({}, item);
        this.editSubComplexModal = true;
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    updateSubComplex(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/locationNetworkSubComplex/" + this.editedItem.id, {
            subComplexName: this.editedItem.subComplexName,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            locationNetworkId: this.$route.params.locationNetworkId,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("subComplexUpdate"), (this.editSubComplexModal = false);
          });
      }
    },

    saveSubComplex() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/locationNetworkSubComplex", {
            subComplexName: this.editedItem.subComplexName,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            locationNetworkId: this.$route.params.locationNetworkId,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("subComplexUpdate"), (this.addSubComplexModal = false);
          });
      }
    },
    edit(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editedItem = Object.assign({}, item);
        //  this.editedItem.percentageVas=item.fibreFarmerSetting.percentageVas,
        //  this.editedItem.percentageBas=item.fibreFarmerSetting.percentageBas,
        //  this.editedItem.basExpense=item.fibreFarmerSetting.basExpense,
        //  this.editedItem.equipmentSaleShared=item.fibreFarmerSetting.equipmentSaleShared,
        //  this.editedItem.fibreFarmerSettingId=item.fibreFarmerSetting.id,
        this.editFibreFarmerModal = true;
      }
    },
    setPosition(item) {
      let streetNumber = item.address_components.find(
        (x) => x.types.filter((y) => y === "street_number").length > 0
      );
      let streetName = item.address_components.find(
        (x) => x.types.filter((y) => y === "route").length > 0
      );
      let suburb = item.address_components.find(
        (x) => x.types.filter((y) => y === "sublocality").length > 0
      );
      let city = item.address_components.find(
        (x) => x.types.filter((y) => y === "locality").length > 0
      );
      let country = item.address_components.find(
        (x) => x.types.filter((y) => y === "country").length > 0
      );

      let obj = {
        geoLatitude: item.geometry.location.lat(),
        geoLongitude: item.geometry.location.lng(),
        streetNumber: streetNumber ? streetNumber.short_name : null,
        streetName: streetName ? streetName.short_name : null,
        town: city ? city.short_name : null,
        suburb: suburb ? suburb.short_name : null,
        city: city ? city.short_name : null,
        country: country ? country.short_name : null,
      };
      Api()
        .put("/locationNetworks/" + this.$route.params.locationNetworkId, obj)
        .then((response) => {
          this.center = this.infoWindowPos;
          this.addressinfo.geoLatitude = obj.geoLatitude;
          this.addressinfo.geoLongitude = obj.geoLongitude;
          this.addressinfo.streetNumber = obj.streetNumber;
          this.addressinfo.streetName = obj.streetName;
          this.addressinfo.suburb = obj.suburb;
          this.addressinfo.town = obj.town;
          this.addressinfo.city = obj.city;
          this.addressinfo.country = obj.country;

          this.infoWinOpen = false;
          this.infoWindowContent = {};
          this.infoWindowPos = {
            lat: 0,
            lng: 0,
          };
        });
    },
    addPolyPoint(data) {
      this.newPolyData.push(
        new google.maps.LatLng(data.latLng.lat(), data.latLng.lng())
      );
    },
      deletePolygon(){
confirm("Are you sure you want to delete the coverage polygon?")&&
Api().put('/locationNetworkPolygon/'+this.polygon.id, {isActive: false, isDeleted: true}).then(()=>{
  this.getNetworkPolygon()
})
    },
    saveNewPolygon() {
      // let data = this.newPolyData.map((x) => [x.lng(), x.lat()]);
      let data = this.newPolyData
      data = [data];
      if (!this.polyData||this.polyData.length ==0) {
        Api()
          .post("/locationNetworkPolygon", {
            locationNetworkId: this.$route.params.locationNetworkId,
            coordinates: JSON.stringify(data),
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.addPolygon = false;
            this.polyData = data
          });
      } else {
        Api()
          .put("/locationNetworkPolygon/" + this.polygon.id, {
            coordinates: JSON.stringify(data),
          })
          .then((response) => {
            this.addPolygon = false;
            this.polyData = data
          });
      }
      
    },
    updateNewPolygon(data) {
      // this.newPolyData = data.i[0].i;
      let key = Object.keys(data)[0]
      let array = data[key][0][key].map((x) => [x.lng(), x.lat()]);
      this.newPolyData = array;
    },
    deletePolygon(){
confirm("Are you sure you want to delete the coverage polygon?")&&
Api().put('/locationNetworkPolygon/'+this.polygon.id, {isActive: false, isDeleted: true}).then(()=>{
  this.getNetworkPolygon()
})
    },
    getAddressData: async function (addressData, placeResultData, id) {

      var latlng = new google.maps.LatLng(
        addressData.latLng.lat(),
        addressData.latLng.lng()
      );
      this.infoWindowPos = {
        lat: addressData.latLng.lat(),
        lng: addressData.latLng.lng(),
      };
      let resultData = null;
    var geocoder = new google.maps.Geocoder();
      await geocoder.geocode(
        {
          latLng: latlng,
        },
        async function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              // resultData=results[1]
              // console.log(this.infoWindowContent)
              resultData = results[1];
            } else {
              alert("No results found");
            }
          } else {
            alert("Geocoder failed due to: " + status);
          }
        }
      );
      setTimeout(() => {
        this.infoWindowContent = resultData;
        this.key += 1;
      }, 3000);
      setTimeout((this.infoWinOpen = true), 1600);
      
    },
    editFibreFarmerSettings() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/fibrefarmerlocationnetwork/" + this.editedItem.id, {
            locationNetworkId: this.$route.params.locationNetworkId,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            type: this.editedItem.type,
            vasProfitPercentage: this.editedItem.vasProfitPercentage,
            basProfitPercentage: this.editedItem.basProfitPercentage,
            vasExpense: this.editedItem.vasExpense,
            basExpense: this.editedItem.basExpense,
            isInvestor: this.editedItem.isInvestor,
            purchasedCpe: this.editedItem.purchasedCpe,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("fibreFarmerSettingsUpdated");
            this.close();
          });
      }
    },
    close() {
      (this.addSubComplexModal = false),
        (this.editSubComplexModal = false),
        (this.addFibreFarmerModal = false);
      this.editFibreFarmerModal = false;

      this.editedItem = Object.assign({}, this.defaultItem);
    },
    deleteFibreFarmer(item) {
      this.editedItem = Object.assign({}, item);
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you want to remove this Fibre Farmer from this Network?"
        ) &&
          Api()
            .put("/fibrefarmerlocationnetwork/" + this.editedItem.id, {
              locationNetworkId: this.$route.params.locationNetworkId,
              customerOrganisationId: this.editedItem.customerOrganisationId,
              type: this.editedItem.type,
              vasProfitPercentage: this.editedItem.vasProfitPercentage,
              basProfitPercentage: this.editedItem.basProfitPercentage,
              vasExpense: this.editedItem.vasExpense,
              basExpense: this.editedItem.basExpense,
              isInvestor: this.editedItem.isInvestor,
              purchasedCpe: this.editedItem.purchasedCpe,
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              this.$emit("fibreFarmerSettingsUpdated");
              this.close();
            });
      }
    },
    addFibreFarmer() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/fibrefarmerlocationnetwork", {
            locationNetworkId: this.$route.params.locationNetworkId,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            type: this.editedItem.type,
            vasProfitPercentage: this.editedItem.vasProfitPercentage,
            basProfitPercentage: this.editedItem.basProfitPercentage,
            vasExpense: this.editedItem.vasExpense,
            basExpense: this.editedItem.basExpense,
            isInvestor: this.editedItem.isInvestor,
            purchasedCpe: this.editedItem.purchasedCpe,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("fibreFarmerSettingsUpdated");
            this.close();
          });
      }
    },
    save() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let proceed = true;
        if (this.addressinfo.name == "") {
          proceed = false;
          confirm("Please fill in a network name.");
        }
        if (this.addressinfo.locationNodeId == null) {
          proceed = false;
          confirm("Please select an associated network node.");
        }
        if (
          this.addressinfo.networkStatus == "" ||
          this.addressinfo.networkStatus == null
        ) {
          proceed = false;
          confirm("Please select a network installation status.");
        }
        if (this.addressinfo.streetName == "") {
          proceed = false;
          confirm("Please fill in a street name.");
        }
        if (this.addressinfo.country == "") {
          proceed = false;
          confirm("Please fill in the country.");
        }
        if (
          this.addressinfo.lineRentalIncluded == true &&
          this.addressinfo.residentialLineRentalValue == null
        ) {
          proceed = false;
          confirm("Please fill in the residential BAS amount (excl. VAT).");
        }
        if (proceed == true) {
          Api()
            .put("/locationnetworks/" + this.$route.params.locationNetworkId, {
              name: this.addressinfo.name,
              abbreviation: this.addressinfo.abbreviation,
              locationNodeId: this.addressinfo.locationNodeId,
              lineRentalIncluded: this.addressinfo.lineRentalIncluded,
              residentialLineRentalValue: this.addressinfo
                .residentialLineRentalValue,
              businessLineRentalValue: this.addressinfo.businessLineRentalValue,
              tvOverFibre: this.addressinfo.tvOverFibre,
              gtuIncluded: this.addressinfo.gtuIncluded,
              gtuFee: this.addressinfo.gtuFee,
              activationFee: this.addressinfo.activationFee,
              activationFeeAmount: this.addressinfo.activationFeeAmount,
              routerInstallationFee: this.addressinfo.routerInstallationFee,
              customerOrganisationId: this.addressinfo.customerOrganisationId,
              residentialRouterInstallationFeeAmount: this.addressinfo
                .residentialRouterInstallationFeeAmount,
              businessRouterInstallationFeeAmount: this.addressinfo
                .businessRouterInstallationFeeAmount,
              hasSingleLineRentalCustomer: this.addressinfo
                .hasSingleLineRentalCustomer,
              networkStatus: this.addressinfo.networkStatus,
              backhaulType: this.addressinfo.backhaulType,
              streetNumber: this.addressinfo.streetNumber,
              streetName: this.addressinfo.streetName,
              suburb: this.addressinfo.suburb,
              town: this.addressinfo.town,
              city: this.addressinfo.city,
              country: this.addressinfo.country,
              geoLongitude: this.addressinfo.geoLongitude,
              geoLatitude: this.addressinfo.geoLatitude,
              geoHightAboveGroundLevel: this.addressinfo
                .geoHightAboveGroundLevel,
                isMDU: this.addressinfo.isMDU
            })
            .then((response) => {
              if (response.status === 200) {
                this.text = `Successfully Saved Changes!`;
                this.snackbar = true;
              }
            });
        }
      }
    },
  },
};
</script>
<style>
.autoCompleteGlueTheme {
  border-bottom: 1px solid grey !important;
  color: black !important;
}
.theme--light.v-text-field--solo-inverted.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background-color: transparent !important;
  color: black !important;
}
.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  .v-label,
.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  input {
  color: black !important;
}
</style>


